import img1 from "../images/layouts/team-10.jpg";
import img2 from "../images/layouts/team-11.jpg";
import img3 from "../images/layouts/team-13.jpg";
import img4 from "../images/layouts/team-04.png";
import img5 from "../images/layouts/team-05.png";

const dataTeam = [
  {
    id: 1,
    img: img1,
    name: "Shin yeongbin",
    position: "CEO & AI Engineer",
    instagram: "https://www.instagram.com/sinobin_",
    github: "https://github.com/youngbin03",
  },
  {
    id: 2,
    img: img2,
    name: "Shin sanghyun",
    position: "CTO & Frontend Developer",
    instagram: "https://www.instagram.com/hot._.hyun",
    github: "https://github.com/HotHyun",
  },

  {
    id: 3,
    img: img3,
    name: "Kim minseung",
    position: "Backend Developer",
    instagram: "https://www.instagram.com/rkms027",
    github: "https://github.com/RogerKimJazzLover",
  },

  {
    id: 4,
    img: img4,
    name: "?",
    position: "Designer",
  },

  {
    id: 5,
    img: img5,
    name: "?",
    position: "3D Artist",
  },
];

export default dataTeam;
